import AppEditorMixin from "@/protected/mixins/AppEditorMixin";
import AttachmentsForm, {
  onAttachmentEvent,
  onAttachmentsTabSelected
} from "@/protected/components/AttachmentsForm";
import service from "./NetworkService";
import NetworkForm from "./NetworkForm";
import NetworkSettingsForm from "./NetworkSettingsForm";

const contextList = [
  {
    label: "Allegati rete - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: "networks",
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    getId: value => value.id,
    getPermissions: value =>
      value.permissions.attachments.BROKER_CUSTOMER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni richiesta</strong> ' +
      'ed <strong class="text-dark">ogni pratica</strong> ' +
      "collegate a questa " +
      '<strong class="text-primary">rete</strong>.'
  },
  {
    label: "Allegati rete - Visibilità: Gestori/Clienti",
    serverPath: "networks",
    subcontext: "BROKER_CUSTOMER",
    getId: value => value.id,
    getPermissions: value => value.permissions.attachments.BROKER_CUSTOMER,
    message:
      "I file caricati in questa sezione sono visibili solamente " +
      'da <strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">clienti</strong>, ma ' +
      'non dai <strong class="text-danger">fornitori</strong> ' +
      "e sono richiamabili da " +
      '<strong class="text-dark">ogni richiesta</strong> ed ' +
      '<strong class="text-dark">ogni pratica</strong> ' +
      "collegata a questa " +
      '<strong class="text-primary">rete</strong>.'
  },
  {
    label: "Allegati rete - Visibilità: Gestori/Fornitori",
    serverPath: "networks",
    subcontext: "BROKER_PROVIDER",
    getId: value => value.id,
    getPermissions: value => value.permissions.attachments.BROKER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili solamente " +
      'da <strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">fornitori</strong>, ma ' +
      'non dai <strong class="text-danger">clienti</strong> ' +
      "e sono richiamabili da " +
      '<strong class="text-dark">ogni richiesta</strong> ed ' +
      '<strong class="text-dark">ogni pratica</strong> ' +
      "collegata a questa " +
      '<strong class="text-primary">rete</strong>.'
  }
];

export default {
  mixins: [AppEditorMixin],

  created() {
    this.tabs = [
      {
        component: NetworkForm,
        title: () => this.$t("network.tabs.main"),
        icon: "users",
        props: () => ({
          isNew: this.isNew
        })
      },
      {
        component: NetworkSettingsForm,
        title: () => this.$t("network.tabs.settings"),
        icon: "tasks",
        show: () => this.value.permissions.changeSettings,
        props: {
          value: this.value.settings
        },
        events: {
          input: settings => {
            this.propertyChange("settings", settings);
          }
        }
      },
      {
        id: "attachments",
        component: AttachmentsForm,
        title: () => this.$t("network.tabs.attachments"),
        icon: "paperclip",
        show: !this.isNew,
        props: {
          contextList
        },
        events: {
          "attachment-event": onAttachmentEvent.bind(this)
        },
        tabSelected: onAttachmentsTabSelected.bind(this)
      }
    ];
  },

  methods: {
    getService() {
      return service;
    }
  }
};
